export default {
    username: [{required: true, message: 'Please input your username!'}],
    password: [{required: true, message: 'Please input your password!'}, {min: 4, message: 'Minimal password length is 4!'}]
};